import * as actionTypes from "../actionTypes/actionTypes";
import {
  getLayerRuleService,
  getLayerService,
  deleteLayer,
  createNewLayerRule
} from "../services/LayerService";

const getLayerRules = (layerId) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.GET_LAYER_RULE,
    });
    getLayerRuleService(layerId)
      .then((response) => {
        const data = response.data[0];
        dispatch({
          type: actionTypes.GET_LAYER_RULE_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.GET_LAYER_RULE_FAILURE,
          payload: error,
        });
      });
  };
};

const updatelayerRules = (gridData) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.GET_LAYER_SUCCESS,
      payload: gridData,
    });
  };
};

const getLayers = (drawingId) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.GET_LAYER,
    });
    getLayerService(drawingId)
      .then((response) => {
        const data = response.data;

        dispatch({
          type: actionTypes.GET_LAYER_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.GET_LAYER_FAILURE,
          payload: error,
        });
      });
  };
};

const deleteLayerRule = (requestPayload) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.DELETE_LAYER_RULE,
    });
    deleteLayer(requestPayload)
      .then((response) => {
        const data = response.data;
        dispatch({
          type: actionTypes.DELETE_LAYER_RULE_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.DELETE_LAYER_RULE_FAILURE,
          payload: error,
        });
      });
  };
};

const createLayerRules = (requestPayload) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.CREATE_LAYER_RULE,
    });
    await createNewLayerRule(requestPayload)
      .then((response) => {
        const data = response.status;
        dispatch({
          type: actionTypes.CREATE_LAYER_RULE_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.CREATE_LAYER_RULE_FAILURE,
          payload: error,
        });
      });
  };
};

export { getLayerRules, getLayers, updatelayerRules, deleteLayerRule, createLayerRules };
